import { TRecordValue } from '../types/TRecordValue';

export function renderValue(value: TRecordValue) {
  if (Array.isArray(value)) {
    return value.length ? value.join(', ') : 'Not found';
  }

  if (value === undefined || value === '') {
    return 'Not found';
  }

  return String(value);
}
